import i18n from '@shared/i18n'
import { ParticipantRole } from '@shared/models/interfaces/conversations'

export const defaultParticipantNameMap: Record<ParticipantRole, string> = {
  [ParticipantRole.INTERPRETER]: i18n.global.t('chat.labels.interpreterLabel'),
  [ParticipantRole.PATIENT]: i18n.global.t('chat.labels.patient'),
  [ParticipantRole.USER]: i18n.global.t('chat.labels.agent'),
  [ParticipantRole.VIDEO_CALL_GUEST]: i18n.global.t('chat.labels.guest'),
  [ParticipantRole.VISITOR]: i18n.global.t('chat.labels.visitor'),
} as const

export const DISCONNECT_TIMEOUT = 5 * 60 * 1000 // 5 minutes
